import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import WhatsAppWidget from "@/components/site/WhatsAppWidget";
import ScrollToTop from "@/components/site/ScrollToTop";
import useLenis from "@/hooks/useLenis";

export default function SiteLayout() {
  useLenis(true);
  return (
    <div className="min-h-screen bg-ink-950 text-white">
      <ScrollToTop />
      <Navbar />
      <main>
        <Outlet />
      </main>
      <Footer />
      <WhatsAppWidget />
    </div>
  );
}
